<template>
    <div id="header">
        <img id="logo" :src="siteLogo" alt="" onerror="this.style.display = 'none';"/>
    </div>
</template>

<script>
    import axios from "axios";
    import { appSettings } from "../mixins/app-settings";

    export default {
        name: "Header",
        mixins: [appSettings],
        data: function() {
            return {
                siteLogo: null
            }
        },
        async mounted() {

            if (this.$route.query.at) {
                axios.defaults.headers.common['Authorization'] = "Token " + encodeURI(this.$route.query.at.replace("Token", "").trim());
            }

            if (this.$route.query.a !== undefined && this.$route.query.s !== undefined) {
                const url = this.getApiBaseUrl() + "/site/sitelogo/" + this.$route.query.s + "/" + this.$route.query.a;
                const vm = this;
                await axios.get(url)
                    .then(response => {
                        if (response.data) {
                            vm.siteLogo = response.data
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        vm.siteLogo = undefined;
                    })
            }
        }
    }
</script>

<style scoped>
    #header {
        background-color: var(--darker-gray);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    #logo {
        height: 50px;
    }
</style>